var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionSettings12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 11l-.2-1.6a1.888 1.888 0 01-.306-.15 4.081 4.081 0 01-.281-.188l-1.488.626-1.375-2.376 1.288-.974a1.194 1.194 0 01-.013-.17v-.337c0-.054.004-.11.013-.169l-1.288-.974L2.85 2.313l1.488.624a3.37 3.37 0 01.287-.187c.1-.058.2-.108.3-.15l.2-1.6h2.75l.2 1.6c.108.042.21.092.307.15.095.058.189.12.28.188l1.488-.626 1.375 2.376-1.287.974c.008.059.012.115.012.169v.337a.609.609 0 01-.025.17l1.288.974-1.375 2.375-1.475-.624a3.554 3.554 0 01-.288.187c-.1.058-.2.108-.3.15l-.2 1.6h-2.75zm1.4-3.25c.483 0 .896-.17 1.238-.513.341-.341.512-.754.512-1.237 0-.483-.17-.896-.512-1.237a1.686 1.686 0 00-1.238-.513c-.492 0-.906.17-1.244.513A1.697 1.697 0 004.775 6c0 .483.169.896.506 1.237a1.68 1.68 0 001.244.513z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSettings12);
export default __webpack_public_path__ + "c2f2bcba6c38fee523ff6d2443f4982f.svg";
export { ForwardRef as ReactComponent };